import type { LatLng } from '@greensm/api-client';

/** Khoá cache tập trung – tránh gõ chuỗi rải rác và sai lệch giữa nơi đọc/ghi. */
export const qk = {
  places: (q: string) => ['places', q] as const,
  quote: (origin: LatLng, destId: string) => ['quote', origin.lat, origin.lng, destId] as const,
  command: (id: string) => ['command', id] as const,
  trip: (id: string) => ['trip', id] as const,
  tripTimeline: (id: string) => ['trip', id, 'timeline'] as const,
  activeTrip: ['trips', 'active'] as const,
  history: (state: string) => ['trips', 'history', state] as const,
  plan: (id: string) => ['plan', id] as const,
  tickets: ['support', 'tickets'] as const,
  ticket: (id: string) => ['support', 'ticket', id] as const,
  homeFeed: ['home', 'feed'] as const,
  notifications: (category: string) => ['notifications', category] as const,
  /** Dữ liệu API v3 – mọi khoá bắt đầu bằng 'v3' để `resync` làm mới một lần. */
  v3: {
    all: ['v3'] as const,
    me: ['v3', 'me'] as const,
    currentTrip: ['v3', 'trip', 'current'] as const,
    trip: (id: string) => ['v3', 'trip', id] as const,
    floods: ['v3', 'floods'] as const,
    conversation: ['v3', 'conversation'] as const,
    history: (state: string) => ['v3', 'history', state] as const,
    historyTrip: (id: string) => ['v3', 'history-trip', id] as const,
    historyTimeline: (id: string) => ['v3', 'history-trip', id, 'timeline'] as const,
  },
} as const;
